<div class="dialog-content-wrapper" cslPerfectScrollbar>
  <div mat-dialog-title>
    <span i18n class="title dialog-title">Импорт из файла CSV</span>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="p-0 pb-0 m-0" fusePerfectScrollbar>
    <div class="flex flex-col justify-start items-stretch gap-2 py-2">
      <div class="flex flex-row justify-between items-center gap-2">
        <div i18n class="pl-4">Схема</div>
        <mat-form-field appearance="outline" class="flex-1 dense-input no-label no-subscript">
          <mat-select [(ngModel)]="selectedSchema" (selectionChange)="toggleActive($event.value)">
            <mat-option *ngFor="let item of csvSchemas" [value]="item">
              <span>{{ item.name }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="flex flex-row items-center">
          <button
            [disabled]="!selectedSchema"
            i18n-matTooltip
            mat-icon-button
            [matTooltip]="selectedSchema?.byDefault ? 'Просмотр схемы' : 'Редактировать схему'"
            (click)="openEditSchemaDialog()">
            <mat-icon>{{ selectedSchema?.byDefault ? 'visibility' : 'settings' }}</mat-icon>
          </button>

          <button i18n-matTooltip mat-icon-button matTooltip="Добавить схему" (click)="openNewSchemaDialog()">
            <mat-icon>add_circle_outline</mat-icon>
          </button>

          <button
            i18n-matTooltip
            [disabled]="selectedSchema?.byDefault || !selectedSchema"
            mat-icon-button
            matTooltip="Удалить схему"
            (click)="deleteSchema()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <mat-form-field appearance="outline" class="px-2 dense-input no-subscript">
        <mat-label i18n>Способ добавления</mat-label>
        <mat-select [(ngModel)]="saveMode">
          <mat-option [value]="0" i18n>Дополнить все панели</mat-option>
          <mat-option [value]="1" i18n>Добавить только новые</mat-option>
          <mat-option [value]="2" i18n>Заменить существующие</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-divider></mat-divider>

    <mat-table #table [dataSource]="dataSource" class="butt-replacement-table" cslPerfectScrollbar>
      <!-- Old Butt Column -->
      <ng-container matColumnDef="oldButt">
        <mat-header-cell i18n *matHeaderCellDef>Толщина облицовки</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p class="text-truncate">{{ item.thichness }}mm</p>
        </mat-cell>
      </ng-container>

      <!-- New Butt Column -->
      <ng-container matColumnDef="newButt">
        <mat-header-cell i18n *matHeaderCellDef>Новая облицовка</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <mat-form-field appearance="outline" class="w-full dense-input no-label no-subscript">
            <mat-select [(ngModel)]="item.butt" #newButtSelect>
              <mat-option *ngFor="let otherButt of otherButts" [value]="otherButt">
                {{ otherButt.sign }} ({{ otherButt.thickness }}mm)
              </mat-option>

              <mat-option *ngFor="let buttInColor of buttsInColorList" [value]="buttInColor">
                {{ buttInColor.sign }} ({{ buttInColor.thickness }}mm)
              </mat-option>

              <mat-option i18n [value]="item.butt" (click)="setButtFromMatBase(item, newButtSelect)"
                >Другая…</mat-option
              >
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row class="butt-replacement-row" *matRowDef="let item; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="flex flex-row justify-between items-center">
    <button i18n class="mat-accent" mat-raised-button (click)="fileInput.click()">Загрузить</button>
    <input
      type="file"
      #fileInput
      hidden
      accept=".csv"
      (change)="uploadFile($any($event.target).files[0]); $any($event.target).value = null" />

    <button i18n mat-raised-button class="mat-accent" (click)="saveAndClose()" [disabled]="csvPanels.length === 0"
      >Применить</button
    >
  </div>
</div>
